import { createAction, createReducer } from '@reduxjs/toolkit';
import { useMemo, useReducer } from 'react';

type PrivateLabelContent = 'BASIC_INFO_FORM' | 'LIST_VIEWERS' | 'ADD_VIEWERS';

export type LabelCreateModalState =
  | { type: 'PUBLIC_LABEL'; content: 'BASIC_INFO_FORM' }
  | { type: 'PRIVATE_LABEL'; content: PrivateLabelContent };

const initialState: LabelCreateModalState = { type: 'PUBLIC_LABEL', content: 'BASIC_INFO_FORM' };

const changeToPrivateLabel = createAction('changeToPrivateLabel');

const changePrivateLabelView = createAction<PrivateLabelContent>('changePrivateLabelView');

const reducer = createReducer<LabelCreateModalState>(initialState, (builder) =>
  builder
    .addCase(changeToPrivateLabel, (state) => {
      if (state.type === 'PUBLIC_LABEL') {
        return { type: 'PRIVATE_LABEL', content: 'LIST_VIEWERS' };
      }
      return state;
    })
    .addCase(changePrivateLabelView, (state, action) => {
      if (state.type === 'PRIVATE_LABEL') {
        state.content = action.payload;
      }

      return state;
    })
);

export default function useLabelCreateModalState() {
  const [state, dispatch] = useReducer(reducer, reducer.getInitialState());

  return useMemo(
    () => ({
      state,
      changeToPrivateLabel: () => dispatch(changeToPrivateLabel()),
      changePrivateLabelView: (view: PrivateLabelContent) => dispatch(changePrivateLabelView(view)),
    }),
    [state]
  );
}
